/**
 * Dependencies
 */
import http from '../../../../../services/HttpService'

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetState = ({ commit }) => {
    commit('RESET_STATE')
}

/**
 * Get the devbudget for a project
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Void}
 */
const getData = ({commit, rootState}) => {
    http.get(`projects/${rootState.route.params.projectId}/devbudget/`)
        .then(res => commit('GET_DATA_SUCCESS', res.data))
        .catch(() => commit('GET_DATA_FAILURE'))
}

export default {
    getData,
    resetState
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/devbudget/actions.js